(function(document, window, $) {
  'use strict';

  var Site = window.Site;

  $(document).ready(function($) {
    Site.run();

      window.initSwitchery = function(){

          $('[data-plugin=switchery]').each(function () {
              new Switchery(this, {
                  color: $.colors("primary", 600)
              });
          });
      }


  });



})(document, window, jQuery);
